"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyImageStyling = exports.formatImgURLs = exports.isProxyURL = exports.getSrcFromText = void 0;
const api_1 = __importDefault(require("../../lib/api"));
function getSrcFromText(value) {
    // find all img src=""
    return value
        .split('<img')
        .map((imgStr) => imgStr.slice(0, imgStr.indexOf('>')))
        .join()
        .trim()
        .split('src="')
        .map((dirtyUrl) => {
        dirtyUrl = dirtyUrl.slice(0, dirtyUrl.indexOf('"')) || '';
        return dirtyUrl.trim();
    })
        .slice(1);
}
exports.getSrcFromText = getSrcFromText;
function isProxyURL(url, proxyOptions) {
    return url.includes(proxyOptions.path) && url.includes(proxyOptions.key);
}
exports.isProxyURL = isProxyURL;
// add api token to img urls in text for InputHtml
function formatImgURLs(text, proxyOptions, removeToken = false) {
    // console.log('InputHtml: formatImgURLs');
    // find all img src=""
    // only include proxy URLs
    const urls = getSrcFromText(text).filter(url => {
        return isProxyURL(url, proxyOptions);
    });
    const replaceArr = [];
    for (const url of urls) {
        // convert &amp; to &
        const ampUrl = url.replace(/&amp;/g, '&');
        const paramsStr = ampUrl.split('?')[1] || '';
        // create proxy url with base url that matches api url
        const urlNoParams = api_1.default.getBaseUrl() + proxyOptions.path;
        // check if it has storageKey
        const params = new URLSearchParams(paramsStr);
        const storageKey = params.get(proxyOptions.key);
        if (typeof storageKey !== 'string') {
            continue;
        }
        // if has storage key, format url
        if (removeToken) {
            params.delete('token');
        }
        else {
            // change token to current user token
            params.set('token', api_1.default.getAccessToken() || '');
        }
        const newParamsStr = params.toString();
        const newUrl = urlNoParams + (newParamsStr && '?' + newParamsStr);
        // only replace if different
        if (ampUrl !== newUrl) {
            replaceArr.push({ from: url, to: newUrl });
        }
    }
    for (const replace of replaceArr) {
        text = text.replace(replace.from, replace.to);
    }
    return text;
}
exports.formatImgURLs = formatImgURLs;
// broken image styling
// NOTE: taken from https://stackoverflow.com/a/37192970/7013346
const imageStyle = `
img {
  position: relative;
}

img:after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 16px;
  height: 16px;
  font-size: 15px;
  letter-spacing: 1px;
  background-color: #fff;
  color: rgba(0, 0, 0, 0.54);
  animation: animateLoading 1s infinite;
}

@keyframes animateLoading {
  0% { content: '...'; }
  50% { content: '.'; }
  100% { content: '..'; }
}
`;
// apply styling for failed images
function applyImageStyling(iframe) {
    const doc = iframe === null || iframe === void 0 ? void 0 : iframe.contentDocument;
    if (!doc) {
        return;
    }
    // style manually as this is inside an iframe
    const styleEl = document.createElement('style');
    styleEl.innerHTML = imageStyle;
    doc.head.appendChild(styleEl);
}
exports.applyImageStyling = applyImageStyling;
//# sourceMappingURL=InputHtml.hooks.js.map